var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (playgroundLock) {pug_html = pug_html + "\u003Cdiv id=\"playground-next\"\u003E" + (null == (pug_interp = playgroundLock) ? "" : pug_interp) + "\u003Cdiv class=\"playground-next-loading\"\u003E\u003Cdiv class=\"spinner spinner-md\"\u003E\u003Cdiv class=\"circle\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"playgroundLock" in locals_for_with?locals_for_with.playgroundLock:typeof playgroundLock!=="undefined"?playgroundLock:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/homepage/partials/interactive-lock-section.pug
// module id = 1118
// module chunks = 0